import SecondaryLarge from "./SecondaryLarge";

export default SecondaryLarge;
export { SecondaryLarge as H4 };
